import { useIonViewDidEnter } from '@ionic/react';
import { ReactElement } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { pageViewEvent } from '../config/analytics';
import i18n, { i18nKeyType } from '../i18n';

export interface PageProps extends RouteProps {
  i18nTitleKey?: i18nKeyType;
}

const Page = (props: PageProps): ReactElement => {
  const { i18nTitleKey, ...rest } = props;

  useIonViewDidEnter(() => {
    pageViewEvent(
      i18nTitleKey ? i18n.t(i18nTitleKey, { lng: 'en' }) : undefined
    );
  });

  document.title = `Beacon`;

  return <Route {...rest} />;
};

export { Page };
